import API from "../axiosConfig";

const BASE_URL = "agent-roles";
export const getAgentRoles = async (agentId) => {
  try {
    const response = await API.get(`${BASE_URL}/${agentId}`);
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Assign multiple roles to an agent (replaces existing assignments)
 */
export const assignRoles = async (agentId, roleIds) => {
  try {
    const response = await API.post(`${BASE_URL}/assign`, {
      agent_id: agentId,
      role_ids: roleIds,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

